import { __decorate, __metadata } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { proxy, subscribe } from '@/infrastructure/object-reactive/object-reactive';
let DatasetModelImpl = class DatasetModelImpl {
    constructor() {
        this._dataset = proxy(null);
    }
    get dataset() {
        return this._dataset.value;
    }
    updateDataset(dataset) {
        this._dataset.value = dataset;
    }
    getRowByIndex(index) {
        return this.dataset[index];
    }
    subscribe(callback) {
        return subscribe(() => this._dataset.value, (newVal) => callback(newVal));
    }
};
DatasetModelImpl = __decorate([
    injectable(),
    __metadata("design:paramtypes", [])
], DatasetModelImpl);
export { DatasetModelImpl };
